// src/components/student/student-fee-pdf/student-fee-pdf-buttons.js
import React, { useRef, useState } from 'react';
import { Button, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material';
import { Close, Download, Visibility } from '@mui/icons-material';
import { useReactToPrint } from 'react-to-print';
import FeeCardDocument from './FeeCardDocument';
import { schoolAPI } from '../../../services/api';

const StudentFeePdfButtons = ({ feeData, studentId }) => {
  const printRef = useRef();
  const [school, setSchool] = useState(null);
  const [schoolLoaded, setSchoolLoaded] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  /* Fetch school once, then cache it */
  const ensureSchool = async () => {
    if (schoolLoaded) return;
    try {
      const res = await schoolAPI.get();
      setSchool(res?.data?.data || res?.data || null);
    } catch (e) {
      console.error('Could not load school info', e);
    } finally {
      setSchoolLoaded(true);
    }
  };

  /* react-to-print — triggers browser print dialog (Save as PDF works here) */
  const triggerPrint = useReactToPrint({
    contentRef: printRef,
    pageStyle: '@page { size: A4 portrait; margin: 0; } body { margin: 0; }',
    documentTitle: `Fee_Card_${
      feeData?.student?.registration_no ||
      feeData?.student?.lin ||
      studentId
    }`,
  });

  const handleDownload = async () => {
    setLoading(true);
    try {
      const response = await schoolAPI.get('/students/export-pdf', {
        responseType: 'blob',
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `students_export_${new Date().toISOString().split('T')[0]}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('PDF export failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleView = async () => {
    setLoading(true);
    await ensureSchool();
    setLoading(false);
    setDialogOpen(true);
  };

  return (
    <>
      {/* <Stack direction="row" spacing={1}>
        <Button
          variant="outlined"
          startIcon={<Visibility />}
          size="small"
          onClick={handleView}
          disabled={loading}
        >
          View Fee Card
        </Button>
        <Button
          variant="outlined"
          startIcon={<Download />}
          size="small"
          onClick={handleDownload}
          disabled={loading}
        >
          {loading ? 'Loading…' : 'Print / Save PDF'}
        </Button>
      </Stack> */}

      {/* ── Preview dialog ─────────────────────────────────── */}
      <Dialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography>Fee Card Preview</Typography>
          <IconButton onClick={() => setDialogOpen(false)}>
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 1, bgcolor: '#e0e0e0' }}>
          {/* Same grey-background preview style as the report card dialog */}
          <FeeCardDocument feeData={feeData} school={school} />
        </DialogContent>
      </Dialog>

      {/*
        Hidden off-screen container used by react-to-print.
        Identical pattern to the bulk-print container in ReportCardGeneration.
      */}
      <div style={{ position: 'fixed', top: '-9999px', left: '-9999px', width: '210mm' }}>
        <FeeCardDocument ref={printRef} feeData={feeData} school={school} />
      </div>
    </>
  );
};

export default StudentFeePdfButtons;
